import { memo } from 'react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { showPreferences } from '../../utils/cookieConsentConfig'
import Navbar from './Navbar'

interface LayoutProps {
  children: ReactNode
  currentHome?: "home_a" | "home_b"
  onHomeChange?: (home: "home_a" | "home_b") => void
  selectedChild?: string
  onChildChange?: (childId: string) => void
  childrenData?: any[]
  isLoading?: boolean
  currentView?: "care" | "events"
  onViewChange?: (view: "care" | "events") => void
  onAddEventClick?: () => void
}

const Layout = memo<LayoutProps>(({
  children,
  currentHome = "home_a",
  onHomeChange,
  selectedChild,
  onChildChange,
  childrenData,
  isLoading,
  currentView = "care",
  onViewChange,
  onAddEventClick
}) => {
  return (
    <div className="flex flex-col bg-gray-50">
      <Navbar
        currentHome={currentHome}
        onHomeChange={onHomeChange}
        selectedChild={selectedChild}
        onChildChange={onChildChange}
        children={childrenData}
        isLoading={isLoading}
        currentView={currentView}
        onViewChange={onViewChange}
        onAddEventClick={onAddEventClick}
      />
      <main className="flex-grow container mx-auto px-4 py-1 sm:py-3">
        {children}
      </main>
      <footer className="bg-white/80 border-t border-gray-100 py-2 px-4">
        <div className="flex flex-col items-center justify-center gap-0.5">
            <div className="text-xs text-gray-400">
              © 2026 2domy.pl - Kalendarz opieki online
            </div>

            <div className="text-[11px] text-gray-400 text-center whitespace-nowrap">
              <Link to="/terms" className="hover:underline">Regulamin</Link>
              {' · '}
              <Link to="/polityka-prywatnosci" className="hover:underline">Polityka</Link>
              {' · '}
              <button
                type="button"
                className="hover:underline bg-transparent border-0 p-0 text-inherit text-[11px] cursor-pointer inline"
                onClick={(e) => {
                  e.preventDefault()
                  showPreferences()
                }}
              >
                Zarządzaj zgodą
              </button>
            </div>
          </div>
      </footer>
    </div>
  )
})

export default Layout 